export enum RouteNames {
  MAIN = '/',
  ORDER = '/order',
  ORDER_ID = '/order/:id',
  LOGIN = '/login',
  ADMIN = 'admin',
  ADMIN_CARS_LIST = 'cars-list',
  ADMIN_ORDER_LIST = 'order-list',
  ADMIN_CITY_LIST = 'city-list',
  ADMIN_POINT_LIST = 'point-list',
  ADMIN_CATEGORY_LIST = 'category-list',
  ADMIN_RATE_LIST = 'rate-list',
  ADMIN_RATE_TYPE_LIST = 'rate-type-list',
  ADMIN_ORDER_STATUS_LIST = 'order-status-list',
  ADMIN_CAR = 'car',
  ADMIN_CAR_EDIT = 'car/:id',
  ADMIN_CITY = 'city',
  ADMIN_CITY_EDIT = 'city/:id',
  ADMIN_POINT = 'point',
  ADMIN_POINT_EDIT = 'point/:id',
  ADMIN_CATEGORY = 'category',
  ADMIN_CATEGORY_EDIT = 'category/:id',
  ADMIN_RATE = 'rate',
  ADMIN_RATE_EDIT = 'rate/:id',
  ADMIN_RATE_TYPE = 'rate-type',
  ADMIN_RATE_TYPE_EDIT = 'rate-type/:id',
  ADMIN_ORDER_STATUS = 'order-status',
  ADMIN_ORDER_STATUS_EDIT = 'order-status/:id',
  ADMIN_ORDER = 'order',
  ADMIN_ORDER_EDIT = 'order/:id',
}
